import React, {useEffect, useState} from "react";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import NavItemPositionModalButton from "./navItemPositionModalButton";
import {toggleNavItemPositionModal} from "../../../actions/navigationFunctions";
import {CORNER_SHELVES_POSITIONS, PAN_POSITIONS, SIDE_POSITIONS} from "../../bvSceneComponent/core/constants";
// import {SLAT_WALL_POSITIONS} from "../../commonVisualizer/core/constants";
import {getCurrentLayout} from "../../appLayout";
import {featureInterface} from "../../../interfaces/featureInterface";
import NavItemPositionModalSlatWall from "./navItemPositionModalSlatWall";
// import NavItemPositionModalSlatWallButton from "./navItemPositionModalSlatWallButton";

const disallowBlurClasses = [".nav-pos", ".feature", ".menu-list__item", ".m-feature"];

export const getPositionsArray = (partId) => {
  switch (partId) {
    case "corner_shelf":
      return CORNER_SHELVES_POSITIONS
    // case "slat_wall":
    //   return SLAT_WALL_POSITIONS
    case "shower_pan_combo":
    case "shower_fixture":
    case "grab_bar":
    case "shampoo_shelf":
    case "soap_dish":
      return PAN_POSITIONS
    default:
      return document.kvConfig.visualizerType === "bvState" ? SIDE_POSITIONS : ["L","R", "C"]
      // return ["L","R", "C"]
  }
}

const NavItemPositionModal = (props) => {

  const {navItemPositionModal, toggleNavItemPositionModal, activePartId, windowWidth, windowHeight, isWizard,
    activeFeature} = props;
  const [parent, setParent] = useState(null);
  const [checkboxesUpdated, setCheckboxesUpdated] = useState(true);
  const left = navItemPositionModal.popupPosition.left;
  const top = navItemPositionModal.popupPosition.top;

  const contextMenuBlur = (e) => {
    if ((!disallowBlurClasses.some(cls => e.target.closest(cls)) || e.target.closest(".feature-buttons"))
      && navItemPositionModal.popupOpened) {
      toggleNavItemPositionModal({
        popupOpened: false,
        activePartId: ""
      })
    }
  };

  useEffect(() => {
    document.addEventListener('click', contextMenuBlur);
    return () => {
      document.removeEventListener('click', contextMenuBlur)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navItemPositionModal]);

  useEffect(() => {
    const layout = getCurrentLayout();
    setParent(layout.getFeatureGroupByPartId(activePartId))
  }, [activePartId]);

  const updateCheckboxes = () => {
    setCheckboxesUpdated(!checkboxesUpdated);
  };

  useEffect(() => {
    updateCheckboxes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [left, top, activePartId]);

  if (!navItemPositionModal.popupOpened || !parent) { // added !parent because the buttons were transitioning the modal width after the parent is set
    return null
  }

  const isMobile = windowWidth < 991;
  const maxRight = left > windowWidth - 200;
  const fixedTop = top > (windowHeight - 130) ? windowHeight - 130 : top;
  //
  // console.log("windowHeight", windowHeight);
  // console.log("top", top);
  // console.log("fixedTop", fixedTop);

  const styles = isMobile ? {
    left: maxRight ? "auto" : left + "px",
    top: fixedTop + "px",
    right: maxRight ? 0 : "auto"
  } : {
    transform: `translate(${maxRight ? left - 200 : left}px, ${fixedTop}px)`,
  }

  const triangleStyles = isMobile ? {
    left: left + "px",
    top: fixedTop + "px",
    position: "fixed",
    marginTop: 10,
  } : maxRight ? {
    left: "auto",
    right: "40px"
  } : {}

  const isShelf = activePartId === "corner_shelf";
  const isSlatWall = activePartId === "slat_wall";

  if (isSlatWall) {
    return <NavItemPositionModalSlatWall styles={styles}
                                         triangleStyles={triangleStyles}
                                         parent={parent}
                                         isWizard={isWizard}
                                         activeFeature={activeFeature}
                                         updateCheckboxes={updateCheckboxes}
                                         checkboxesUpdated={checkboxesUpdated}/>
  }

  let positionsArray = getPositionsArray(activePartId);

  positionsArray = positionsArray.filter(pos => {
    return parent && parent.getMatchingPositionFeature(pos, activeFeature);
  });

  return (
    <div className={"nav-pos" + (positionsArray.length > 3 ? " nav-pos--shelf" : "")
    + (positionsArray.length === 3 ? " nav-pos--three" : "") + (isWizard ? " nav-pos--wizard" : "")}
         style={styles}>
      <span className="nav-pos__triangle" style={triangleStyles}/>
      <div className="nav-pos__content">
        <div className="nav-pos__content-top">
          <h4 className="nav-pos__title bold">{isShelf ? "Left" : "Side"}</h4>
          <div className="nav-pos__buttons">
            {positionsArray.slice(0, 3).map((shelf, shelfIndex) => {
              return <NavItemPositionModalButton position={shelf}
                                                 parent={parent}
                                                 key={shelfIndex}
                                                 activeFeature={activeFeature}
                                                 updateCheckboxes={updateCheckboxes} checkboxesUpdated={checkboxesUpdated}/>
            })}
          </div>
        </div>
        {isShelf && (positionsArray.length > 3) ? (
          <div className="nav-pos__content-bottom">
            <h4 className="nav-pos__title bold">Right</h4>
            <div className="nav-pos__buttons">
              {positionsArray.slice(3, 6).map((shelf, shelfIndex) => {
                return <NavItemPositionModalButton position={shelf}
                                                   parent={parent}
                                                   key={shelfIndex}
                                                   activeFeature={activeFeature}
                                                   updateCheckboxes={updateCheckboxes} checkboxesUpdated={checkboxesUpdated}/>
              })}
            </div>
          </div>
        ) : null}
      </div>
    </div>
  )
};

NavItemPositionModal.propTypes = {
  // feature: PropTypes.object.isRequired
  activeFeature: PropTypes.shape(featureInterface),
  isWizard: PropTypes.bool
}

const mapStateToProps = (store, ownProps) => {
  const {windowHeight, windowWidth} = store.serverState;
  return {
    navItemPositionModal: store.navigationState.navItemPositionModal,
    activeFeature: ownProps.activeFeature || store.selectionState.activeFeature,
    activePartId: store.navigationState.navItemPositionModal.activePartId,
    windowHeight,
    windowWidth,
  };
};

const mapDispatchToProps = {
  toggleNavItemPositionModal
};

export default connect(mapStateToProps, mapDispatchToProps)(NavItemPositionModal)
